/**
 * @generated SignedSource<<5ea2969430b7a59ef5163760bb777348>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProposalsVotedRowFragment$data = {
  readonly delegateMetrics: {
    readonly ofTotalProps: number;
    readonly totalVotes: number;
  };
  readonly " $fragmentType": "ProposalsVotedRowFragment";
};
export type ProposalsVotedRowFragment$key = {
  readonly " $data"?: ProposalsVotedRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProposalsVotedRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProposalsVotedRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DelegateMetrics",
      "kind": "LinkedField",
      "name": "delegateMetrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalVotes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ofTotalProps",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "68369794be21958107586bc3197fc084";

export default node;
